(function (window, document, undefined) {
  var ModalScontoMassivoController = function (
    $scope,
    $modalInstance,
    gestioneRaccomandazioneService,
    messaggiFctr,
    labelSrvc,
    CONSTANTS
  ) {
    this.messaggiFctr = messaggiFctr;
    $scope.msg = labelSrvc.getLabel;

    this.boxconfirm = false;

    this.service = gestioneRaccomandazioneService;
    this.spinner = false;
    this.quantitaSconto = null;

    var self = this;

    this.apriSconto = function () {
      self.spinner = true;
      self.service
        .promiseVerificaScontoMassivo(
          self.service.raccomandazione.idPratica,
          self.quantitaSconto
        )
        .then(
          function (response) {
            if (self.messaggiFctr.processaResponse(response)) {
              self.spinner = false;
              return;
            }
            if (self.service.checkVerifica(response.data)) {
              // Verifica OK, procedo al salvataggio
              return self.salvaSconto();
            }
            // Apro alert di conferma
            self.boxconfirm = true;

            self.spinner = false;
          },
          function (reason) {
            self.messaggiFctr.processaResponse(reason);
            self.spinner = false;
          }
        );
    };

    this.salvaSconto = function () {
      self.spinner = true;
      self.service
        .promiseSalvascontoMassivo(
          self.service.raccomandazione.idPratica,
          self.quantitaSconto
        )
        .then(
          function (response) {
            if (self.messaggiFctr.processaResponse(response)) {
              return;
            }
            $modalInstance.close();
          },
          function (reason) {
            self.messaggiFctr.processaResponse(reason);
          }
        )
        .finally(function () {
          self.spinner = false;
        });
    };

    this.close = function () {
      $modalInstance.dismiss();
    };
  };

  ModalScontoMassivoController.$inject = [
    '$scope',
    '$uibModalInstance',
    'gestioneRaccomandazioneService',
    'FinMessaggiFctr',
    'FinLabelSrvc',
    'FIN_CONSTANTS'
  ];

  angular
    .module('cbl.finanza.mf')
    .controller('ModalScontoMassivoController', ModalScontoMassivoController);
})(window, document);



/*****************
 ** WEBPACK FOOTER
 ** ./app/components/modalScontoMassivo/modalScontoMassivo.ctrl.js
 ** module id = 43
 ** module chunks = 1 2
 **/